<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }" class="w-100">
            <div class="header">
              <h2>Add Funds to Wallet</h2>
            </div>
            <div class="body add-fund-form">
              <form
                @submit.prevent="passes(remitterDataSubmit)"
                id="basic-form"
                class="e-wallet"
              >
                <div class="pb-4">
                  <div
                    :class="{ 'close-btn': remitterCredits.length > 1 }"
                    class="middleware-list mb-3 card p-3"
                    v-for="(item, index) in remitterCredits"
                    :key="index"
                  >
                    <ValidationProvider
                      name="customer"
                      rules="required"
                      v-slot="{ errors }"
                      class="flex-grow-1"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group mb-0 form-select multiselect-grp"
                          :class="{
                            errors: errors.length && item.customer.length == 0,
                            success: item.customer.length != 0,
                          }"
                        >
                          <span class="float-label">
                            <label for="customer">Select Customer</label>
                            <v-select
                              :options="options"
                              multiple
                              v-model="item.customer"
                              @search="searchCustomer"
                              @option:selected="selectCustomer"
                              :get-option-label="(option) => option.name"
                            >
                              <template #option="{ name, email }">
                                {{ name + ` (${email})` }}
                              </template>
                            </v-select>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && item.customer.length == 0"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="item.customer.length != 0"
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      :name="'amount' + index"
                      rules="required"
                      v-slot="{ errors }"
                      class="flex-grow-1"
                    >
                      <div
                        class="form-group mb-0"
                        :class="{
                          errors: errors.length && !item.amount,
                          success: item.amount,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="item.amount"
                            class="form-control"
                            :id="'amount' + index"
                            placeholder="amount*"
                            @keypress="onlyNumber($event)"
                          />
                          <label :for="'amount' + index" class="control-label">
                            Enter Amount to add to Wallet*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !item.amount"
                          ></i>
                          <i class="fa fa-check" v-if="item.amount"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="credit_type"
                      rules="required"
                      v-slot="{ errors }"
                      class="flex-grow-1"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group mb-0 form-select multiselect-grp"
                          :class="{
                            errors: errors[0],
                            success:
                              item.creditType &&
                              item.creditType.length != 0 &&
                              !errors[0],
                          }"
                        >
                          <span class="float-label">
                            <label for="credit_type">Select Credit Type*</label>
                            <multiselect
                              placeholder=""
                              v-model="item.creditType"
                              :show-labels="false"
                              :options="creditType_Options"
                              :searchable="false"
                            ></multiselect>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && errors[0]"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="
                                item.creditType &&
                                item.creditType.length != 0 &&
                                !errors[0]
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      :name="'comment' + index"
                      rules="required"
                      v-slot="{ errors }"
                      class="flex-grow-1"
                    >
                      <div
                        class="form-group mb-0"
                        :class="{
                          errors: errors.length && !item.comment,
                          success: item.comment,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="item.comment"
                            class="form-control"
                            :id="'comment' + index"
                            placeholder="comment*"
                          />
                          <label :for="'comment' + index" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !item.comment"
                          ></i>
                          <i class="fa fa-check" v-if="item.comment"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div v-if="remitterCredits.length > 1">
                      <b-button
                        class="fliter-btn"
                        variant="outline-danger"
                        @click="remove(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-right">
                    <b-button
                      :class="{ 'add-btn': remitterCredits.length > 1 }"
                      class="w-auto"
                      variant="outline-primary"
                      @click="append"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more
                    </b-button>
                  </div>
                </div>
                <div class="d-flex align-items-center m-b-20">
                  <div class="custom-switch success-error-bg mr-2">
                    <input
                      type="checkbox"
                      class="custom-switch-input"
                      id="customSwitch1"
                      v-model="sendNotification"
                    />
                    <label class="custom-switch-label" for="customSwitch1">
                      <span class="custom-switch-text1">Yes</span>
                      <span class="custom-switch-text2">No</span>
                    </label>
                  </div>
                  <label class="mb-0" for="customSwitch1">
                    Send Notification to Customer?
                  </label>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "vue-select/dist/vue-select.css";
import { mapState, mapGetters } from "vuex";
export default {
  name: "CreateRemitterCreditComponent",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    "v-select": () => import("vue-select"),
  },
  data() {
    return {
      isSelectFrom: false,
      remitterCredits: [
        {
          customer: [],
          comment: "",
          amount: "",
          creditType: "",
        },
      ],
      sendNotification: true,
      creditType_Options: [
        "Promotional Credit",
        "Goodwill Gesture",
        "Refund",
        "Referral Credit",
        "Credit",
      ],
      customers: [],
      options: [],
    };
  },
  methods: {
    append() {
      this.remitterCredits.push({
        customer: [],
        comment: "",
        amount: "",
        creditType: "",
      });
    },
    // to remove
    remove(index) {
      this.remitterCredits.splice(index, 1);
    },
    remitterDataSubmit() {
      console.log(this.remitterCredits);
    },
    searchCustomer() {
      this.options = [
        { name: "Adam Driver", email: "AdamD@yopmail.com" },
        { name: "Dominic Torreto", email: "Dominic@hotmail.co" },
        { name: "Brain O'Conner", email: "connerBrain@mailinator.com" },
        { name: "Mark Chalamet", email: "mark21@test.com" },
        { name: "Robert Evans", email: "robEv12@yahoo.com" },
        { name: "Emma Thomas", email: "emthomas@mail.com" },
        { name: "Alizee Thomas", email: "alizze.th@hotmail.com" },
        { name: "Selena Parker", email: "selena.tp@test.in" },
        { name: "Hal Chalamet", email: "halC12@gmail.com" },
        { name: "Ben Murphy", email: "benPM99@gmail.com" },
      ];
    },
    selectCustomer() {
      setTimeout(() => {
        this.options = [];
      }, 100);
    },
    // to enter only number
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  mounted() {
    this.options = this.customers;
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
